export const V2_PAYMENT_CARDS_PATH = '/v2/payment/cards';
export const V2_PAYMENT_SETUP_CONFIG_PATH = '/v2/payment/setup-config';
export const V2_PAYMENT_BILLING_GUARD_PATH = '/v2/payment/billing-guard';

export const PAYMENT_METHOD_REQUIRED_FOR_ACTIVE_ENROLLMENT =
  'PAYMENT_METHOD_REQUIRED_FOR_ACTIVE_ENROLLMENT';

export const v2PaymentCardDefaultPath = (cardId: string) =>
  `${V2_PAYMENT_CARDS_PATH}/${cardId}/default`;

export const v2PaymentCardPath = (cardId: string) =>
  `${V2_PAYMENT_CARDS_PATH}/${cardId}`;
